import RestrictedPositions from "./restricted-positions";
import { fillArray } from "../../../../services/common/object-util";

export default class KickKickedFromRestrictedPositions extends RestrictedPositions {
    constructor(props) {
        super(props);
    }

    resolve() {
        const { fieldPosition, homeTeamHasPossession } =
            this.play.contextSnapshot;

        const { fieldLength, endZoneLength, includeEndZoneYardage } =
            this.gameConfig.general;

        const maximumPosition =
            fieldLength + (includeEndZoneYardage ? endZoneLength : 0);
        const minimumPosition = includeEndZoneYardage ? -endZoneLength : 0;

        const restrictedCount = homeTeamHasPossession
            ? maximumPosition - fieldPosition
            : fieldPosition + (includeEndZoneYardage ? endZoneLength : 0);
        const restrictionStartPosition = homeTeamHasPossession
            ? fieldPosition + 1
            : minimumPosition;

        return fillArray(restrictedCount, restrictionStartPosition);
    }
}
